import React from 'react';
import Moment from 'moment';
import { prefix, t } from '../../../../i18n';
import CustomDataTable from '../../shared/CustomDataTable';
import { formatDate } from '../../normalizer';

const tSaleState = prefix('sale_state');

/**
 * Completed Attributions Table component using CustomDataTable
 */
const CompletedAttributionsTable = ({ completedSaleAttributions, pagination, page, onPageChange }) => {
  const handlePageChange = data => {
    if (onPageChange) onPageChange(data)
  };
  const columns = [
    {
      key: 'date',
      label: 'Data contrato',
      sortKey: 'date',
      render: (_v, item) => formatDate(item.date),
    },
    {
      key: 'attribution_at',
      label: 'Data atribuição',
      sortKey: 'attribution_at',
      render: (_v, item) => formatDate(item.attributed_at),
    },
    {
      key: 'user',
      label: 'Utilizador',
      sortKey: 'user',
      render: (_v, item) => (item.user ? item.user.employee_identifier : ''),
    },
    {
      key: 'description',
      label: 'Descrição',
      sortKey: 'description',
    },
  ];

  const sortFn = (data, sort) => {
    return [...data].sort((a, b) => {
      const multiplier = sort.direction === 'asc' ? 1 : -1;
      if (sort.key === 'date' || sort.key === 'attribution_at') {
        const dateA = a[sort.key] ? new Date(a[sort.key]) : new Date(0);
        const dateB = b[sort.key] ? new Date(b[sort.key]) : new Date(0);
        return (dateA - dateB) * multiplier;
      }
      if (sort.key === 'user') {
        const valA = (a.user && a.user.employee_identifier || '').toLowerCase();
        const valB = (b.user && b.user.employee_identifier || '').toLowerCase();
        return valA.localeCompare(valB) * multiplier;
      }
      if (sort.key === 'state') {
        const valA = tSaleState(a.state || '').toLowerCase();
        const valB = tSaleState(b.state || '').toLowerCase();
        return valA.localeCompare(valB) * multiplier;
      }
      const valA = (a[sort.key] || '').toString().toLowerCase();
      const valB = (b[sort.key] || '').toString().toLowerCase();
      return valA.localeCompare(valB) * multiplier;
    });
  };

  const renderRow = (item, index, className) => {
    return (
      <tr
        key={item.id || index}
        className={`data-table__row ${className}__row`}
      >
        <td className={`data-table__cell ${className}__cell ${className}__cell--date`}>
          {formatDate(item.date)}
        </td>
        <td className={`data-table__cell ${className}__cell ${className}__cell--attribution_at`}>
          {formatDate(item.attributed_at)}
        </td>
        <td className={`data-table__cell ${className}__cell ${className}__cell--user`}>
          {item.user ? item.user.employee_identifier : ''}
        </td>
        <td className={`data-table__cell ${className}__cell ${className}__cell--description`}>
          {item.description}
        </td>
      </tr>
    );
  };

  return (
    <CustomDataTable
      className="completed-attributions-table"
      columns={columns}
      data={completedSaleAttributions}
      renderRow={renderRow}
      rowKey={(item) => item.id}
      defaultSort={{ key: 'date', direction: 'desc' }}
      sortFn={sortFn}
      pagination={pagination && pagination.total_pages ? {
        totalPages: pagination.total_pages,
        currentPage: page,
        onPageChange: handlePageChange,
      } : undefined}
      emptyMessage="Não realizou nenhuma correção de utilizador em contratos."
    />
  );
};

export default CompletedAttributionsTable;

